import * as React from 'react';
import { inject, observer } from 'mobx-react';
import InputMask from "react-input-mask";
import { MobxComponent } from '../../../../../mobx/components';
import styled from 'styled-components';
import { MobileModal, MobileModalBody, MobileModalContent, MobileModalFooter, MobileModalHeader, SettingsActionButtonContainer, SettingsActionButtonWrapper, SettingsFormGroup, SettingsFormGroupInput, SettingsFormInputContainer, SettingsFormLabelContainer, SettingsFormLabelLeftContainer, SettingsFormLabelRightContainer, SettingsHeader, SettingsHeaderTextBreadcrumbs, SettingsHeaderTextContainer, SettingsHeaderTextTitle, SettingsHeaderTextWrapper, SettingsSwitchContainer } from '../settings-v2';
import { ButtonV2, MainContainer } from '../../../../components/v2/layout.c';
import { TabGroup, TabItem } from '../settings-v2/receipt-printing';
import { IconArrowDownwardMenu, IconArrowForward, IconClose, IconCopyAlt, IconDelete, IconEdit, IconHelp, IconMoreOptions } from '../../../../components/v2/icons';
import shortid from 'shortid';
import { Button, ButtonGroup, Checkbox, Input, Modal, ModalContent, RotateLoader, SelectAdv, Switch } from '@lib/components';
import { IoIosPause } from 'react-icons/io';
import { FastField } from 'formik';
import { RestaurantForm } from '../../../../../mobx/components/restaurant-form';
import { ListOrderTimesOptions, ListServicesOptionsNoB, logger, RestaurantUtils } from '@lib/common';
import { FieldOpeningHours } from '@lib/components';
import _cloneDeep from "lodash/cloneDeep";
import cloneDeep from 'lodash/cloneDeep';
import { MenuComponents } from '../menus/list.menus';
import { MobileMenus } from '../menus/mobileView/menuList/mobileMenus';
import { RestaurantFormOptionSetV2 } from './option_set_v2';
import { RestaurantOptionSetListV2 } from './list.option_sets';
import { ItemTags } from './item-tags';
import { RestaurantMenuListV2 } from './list.menus';
import { RestaurantDishTagsV2 } from './list-tags';
import { MenuListToolbar } from '../menus/components/menu-list-toolbar';
import { getMenuListFilterPlaceholder, MenuListSortDirection } from '../menus/utils/sortLists';
import { MenuMoreAction } from '../../../../components/v2/menumoreaction';
import { CSVImport } from '../menus/csv-import';
import { MenuVersionHistory } from '../menus/version-history';
import { toJS } from 'mobx';
import { CSVExport } from '../menus/csv-export';
export const MenuCard = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 12px;
align-self: stretch;
word-break: break-all;

border-radius: 4px;
background: var(--Neutral-White, #FEFEFE);

&.desktop-only {
 display: none;

    & > p {
        color: var(--Secondary-Smokey-Grey-1, #6B7270);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }
    @media (min-width: 768px) {
        display: flex;
    }
}


`

export const MenuCardWrapper = styled.div`
display: flex;
align-items: center;
gap: 8px;
align-self: stretch;
justify-content: space-between;
`
export const MenuCardTitle = styled.div`
color: var(--Secondary-Dark-1, #0C202A);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: -0.28px;
`
export const TextEllipsis = styled.p`
color: var(--Secondary-Dark-1, #0C202A);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: -0.28px;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
`

export const MenuCardActionsWrapper = styled.div`
display: flex;
align-items: center;
gap: 16px;
`

export const MenuCardActions = styled.div`
display: none;
align-items: center;
gap: 8px;
@media (min-width: 768px) {
    display: flex;
}
`
export const MenuCardActionsMobile = styled.div`
display:flex;
@media (min-width: 768px) {
    display: none;
}
`


export const MenuCardActionsIconWrapper = styled.div<{bg?:string}>`
display: flex;
align-items: center;
justify-content: center;
gap: 4px;
flex: 1 0 0;
align-self: stretch;
padding: 8px 16px;
height: 40px;
border-radius: 4px;
background: ${({bg}) => bg ? bg : 'var(--Neutral-Gray, #F1F4F7)'};
@media (max-width: 768px) {
	background-color: transparent;
	padding: 0;
	height: 24px;
	width: 24px;
    &.hide-mobile {
		display: none;
	}
}
`
export const MenuCreateActionButton = styled.div`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	gap: 4px;
	border-radius: 4px;
	border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
	background: var(--Neutral-White, #FEFEFE);
	color: var(--Secondary-Dark-Grey-1, #4B4F5E);
	text-align: center;
	font-family: Inter;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 16px
`
export const MenuWrapper = styled.div`
		.mobile-view {
    display: none;
  }
  @media (max-width: 767px) {
    .desktop-view {
      display: none;
    }
    .mobile-view {
      display: flex;
	  padding: none;
    }

`

export const MenuItemColor = styled.div<{color?: string}>`
width: 14px;
height: 14px;
aspect-ratio: 1/1;
cursor: pointer;

border-radius: 2px;
${props => props.color ? `background: ${props.color}`
: `
    background: url(data:image/png;base64,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);
    background-size: contain;
`};
`

interface Props { }
interface State {
    loading: boolean;
	expandedMenus: any;
	activeTab: string;
	createMenu: string;
	menuIndex: number;
	categoryIndex: number;
	panel: MenuComponents | null;
	panel_index: number[];
	copy_type: MenuComponents | null;
	copy_index: number[];
	copy_loading: boolean;
	remove_type: MenuComponents | null;
	remove_index: number[];
	remove_loading: boolean;
	selected_dishes: string[];
	selected_item_id: string;
	selected_tag_index: number;
	filterText: string;
	sortDirection: MenuListSortDirection;
 }
 interface RestaurantDishWithTaxes
	extends T.Schema.Restaurant.Menu.RestaurantDish { }

@inject("store") @observer
export class RestaurantMenusV2 extends MobxComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
			expandedMenus: {},
			activeTab: 'menu',
			createMenu: 'general',
			menuIndex: 0,
			categoryIndex: 0,
			panel: null,
			panel_index: [],
			copy_type: null,
			copy_index: [],
			copy_loading: false,
			remove_type: null,
			remove_index: [],
			remove_loading: false,
			selected_dishes: [],
			selected_item_id: '',
			selected_tag_index: -1,
			filterText: "",
			sortDirection: null,
        }
    }
	toggleMenu = (menuIndex: number) => {
		this.setState((prevState) => ({
		  expandedMenus: {
			...prevState.expandedMenus,
			[menuIndex]: {
			  ...prevState.expandedMenus[menuIndex],
			  expanded: !prevState.expandedMenus[menuIndex]?.expanded,
			},
		  },
		}));
	  };

	  toggleCategory = (menuIndex: number, categoryIndex: number) => {
		this.setState((prevState) => ({
		  expandedMenus: {
			...prevState.expandedMenus,
			[menuIndex]: {
			  ...prevState.expandedMenus[menuIndex],
			  categories: {
				...prevState.expandedMenus[menuIndex]?.categories,
				[categoryIndex]: !prevState.expandedMenus[menuIndex]?.categories?.[categoryIndex],
			  },
			},
		  },
		}));
	  };
	  setPanel = (panel: any | null, panel_index: number[]) => {
		this.setState({ panel, panel_index });
	};
    createPizzaMenu = async () => {
		const menu_id = shortid.generate();

		const category1_id = shortid.generate();
		const category2_id = shortid.generate();
		const category3_id = shortid.generate();

		const dish1_id = shortid.generate();
		const dish2_id = shortid.generate();
		const dish3_id = shortid.generate();
		const dish4_id = shortid.generate();
		const dish5_id = shortid.generate();
		const dish6_id = shortid.generate();
		const dish7_id = shortid.generate();

		const optionset1_id = shortid.generate();
		const optionset2_id = shortid.generate();
		const dish9_id = shortid.generate();

		const menu: T.Schema.Restaurant.Menu.RestaurantMenu = {
			_id: menu_id,
			name: "Pizza Menu",
			display_name: "",
			description: "",
			conditions: {
				times: [],
				services: [],
				hours: [],
				pre_order: {
					enabled: false,
					days_in_advance: 0,
					cutoff_time: "",
				},
				age_restricted: false,
			},
			categories: [
				{
					_id: category1_id,
					menu_id: menu_id,
					name: "Pizzas",
					display_name: "",
					dishes: [
						{
							type: "standard",
							_id: dish1_id,
							menu_id: menu_id,
							category_id: category1_id,
							name: "Magherita",
							display_name: "",
							price: 11.9,
							description:
								"Cheese, tomato & basil with tomato base",
							subtitle: "",
							image: {
								_id: "a5f571db-fbf5-4a4d-80e3-562e1cbf8f87",
								name: "pizza-margherita-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [
								{
									_id: "Sk0rG2UWE",
									name: "Cheese",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "S1SUGhIb4",
									name: "Tomato",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "mirzQ-con",
									name: "Basil",
									active: true,
                                    to: '',
                                    from: ''
								},
							],
							option_sets: [optionset1_id, optionset2_id],
							price_type: "standard",
							choices: [],
							option_set_primary: "",
						},
						{
							type: "standard",
							_id: dish2_id,
							menu_id: menu_id,
							category_id: category1_id,
							name: "Pepperoni",
							display_name: "",
							price: 12.9,
							description:
								"Loaded with pepperonis and cheese on a tomato base",
							subtitle: "",
							image: {
								_id: "6f1e43bd-a365-46d7-9a86-063089271edd",
								name: "pizza-pepperoni-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [
								{
									_id: "SJerI3IW4",
									name: "Cheese",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "ry_SU38-V",
									name: "Pepperoni",
									active: true,
                                    to: '',
                                    from: ''
								},
							],
							option_sets: [optionset1_id, optionset2_id],
							price_type: "standard",
							choices: [],
							option_set_primary: "",
						},
						{
							type: "standard",
							_id: dish3_id,
							menu_id: menu_id,
							category_id: category1_id,
							name: "Chicken",
							display_name: "",
							price: 14.9,
							description:
								"Seasoned chicken, corn, mushrooms and capsicum ",
							subtitle: "",
							image: {
								_id: "aacb1904-1925-4ace-87e4-5b15ff3c5a12",
								name: "pizza-chicken-corn-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [
								{
									_id: "rkjKBnU-N",
									name: "Chicken",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "HkOcB3U-4",
									name: "Corn",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "SkCqB3UZV",
									name: "Mushroom",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "B1FornIWN",
									name: "Capsicum ",
									active: true,
                                    to: '',
                                    from: ''
								},
							],
							option_sets: [optionset1_id, optionset2_id],
							price_type: "standard",
							choices: [],
						},
						{
							type: "standard",
							_id: dish4_id,
							menu_id: menu_id,
							category_id: category1_id,
							name: "Veggie",
							display_name: "",
							price: 12.9,
							description:
								"Tomato and onion with light herb seasoning",
							subtitle: "",
							image: {
								_id: "4b533707-09ea-4e54-8db5-2dd2ba05a1f2",
								name: "veggie-pizza-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [
								{
									_id: "ryx0Ph8-N",
									name: "Tomato Base",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "SkKAw2U-V",
									name: "Onion",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "r1lkO2U-4",
									name: "Pineapple",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "B15Juh8bE",
									name: "Capsicum",
									active: true,
                                    to: '',
                                    from: ''
								},
								{
									_id: "ByExun8bE",
									name: "Cheese",
									active: true,
                                    to: '',
                                    from: ''
								},
							],
							option_sets: [optionset1_id, optionset2_id],
							price_type: "standard",
							choices: [],
						},
					],
				},
				{
					_id: category2_id,
					menu_id: menu_id,
					name: "Combo Deals",
					display_name: "",
					dishes: [
						{
							type: "combo",
							_id: shortid.generate(),
							menu_id: menu_id,
							category_id: category2_id,
							name: "2 Pizzas & 1 Side",
							display_name: "",
							description:
								"Grab any 2 pizzas and any side with this combo",
							subtitle: "",
							price: 29.95,
							tags: [],
							image: null,
							status: null,
							ingredients: [],
							option_sets: [],
							choices: [
								{
									_id: shortid.generate(),
									name: "First Pizza",
									dishes: [
										dish1_id,
										dish2_id,
										dish3_id,
										dish4_id,
									],
									selected: null,
									lpo: 11.9,
								},
								{
									_id: shortid.generate(),
									name: "Second Pizza",
									dishes: [
										dish1_id,
										dish2_id,
										dish3_id,
										dish4_id,
									],
									selected: null,
									lpo: 11.9,
								},
								{
									_id: shortid.generate(),
									name: "Side Dish",
									dishes: [dish5_id, dish6_id, dish7_id],
									selected: null,
									lpo: 4,
								},
							],
							price_type: "standard",
						},
					],
				},
				{
					_id: category3_id,
					menu_id: menu_id,
					name: "Sides",
					display_name: "",
					dishes: [
						{
							type: "standard",
							_id: dish5_id,
							menu_id: menu_id,
							category_id: category3_id,
							name: "Garlic Bread",
							display_name: "",
							price: 4.5,
							description: "",
							subtitle: "",
							image: {
								_id: "87612477-521b-4854-9068-d56adca0576c",
								name: "garlic-bread-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [],
							option_sets: [],
							price_type: "standard",
							choices: [],
						},
						{
							type: "standard",
							_id: dish6_id,
							menu_id: menu_id,
							category_id: category3_id,
							name: "Fries",
							display_name: "",
							price: 4,
							description: "",
							subtitle: "",
							image: {
								_id: "dc42d806-534b-4e51-a2c6-870440391524",
								name: "fries-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [],
							option_sets: [],
							price_type: "standard",
							choices: [],
						},
						{
							type: "standard",
							_id: dish7_id,
							menu_id: menu_id,
							category_id: category3_id,
							name: "Fried Chicken",
							display_name: "",
							price: 7,
							description: "",
							subtitle: "",
							image: {
								_id: "7ebd6e08-efec-4fe1-a2ac-58efdd21e371",
								name: "fried-chicken-600-400.jpeg",
							},
							tags: [],
							status: null,
							ingredients: [],
							option_sets: [],
							price_type: "standard",
							choices: [],
						},
					],
				},
			],
		};

		const option_sets: T.Schema.Restaurant.Menu.RestaurantOptionSet[] = [
			{
				_id: optionset1_id,
				name: "Pizza Menu - Base Choice",
				display_name: "Base Choice",
				show_in_menu: false,
				conditions: {
					required: true,
					multi_select: false,
					quantity_select: false,
					min_options: "",
					max_options: "",
					free_amount: "",
				},
				options: [
					{
						_id: shortid.generate(),
						name: "Classic",
						quantity: 0,
						price: "",
						status: null,
					},
					{
						_id: shortid.generate(),
						name: "Thin",
						quantity: 0,
						price: "",
						status: null,
					},
					{
						_id: shortid.generate(),
						name: "Stuffed Crust",
						quantity: 0,
						price: "4.0",
						status: null,
					},
				],
			},
			{
				_id: optionset2_id,
				name: "Pizza Menu - Extra Toppings",
				display_name: "Extra Toppings",
				show_in_menu: false,
				conditions: {
					required: false,
					multi_select: true,
					quantity_select: false,
					min_options: "",
					max_options: "",
					free_amount: "",
				},
				options: [
					{
						_id: shortid.generate(),
						name: "Extra Onion",
						quantity: 0,
						price: 2,
					},
					{
						_id: shortid.generate(),
						name: "Extra Capsicum",
						quantity: 0,
						price: 2,
					},
					{
						_id: shortid.generate(),
						name: "Extra Mushroom",
						quantity: 0,
						price: 2,
					},
					{
						_id: shortid.generate(),
						name: "Extra Pineapple",
						quantity: 0,
						price: 2,
					},
					{
						_id: shortid.generate(),
						name: "Extra Jalapeños",
						quantity: 0,
						price: 2,
					},
					{
						_id: shortid.generate(),
						name: "Extra Olives",
						quantity: 0,
						price: 2,
					},
					{
						_id: shortid.generate(),
						name: "Extra Chicken",
						quantity: 0,
						price: 3,
					},
					{
						_id: shortid.generate(),
						name: "Extra Beef",
						quantity: 0,
						price: 3,
					},
					{
						_id: shortid.generate(),
						name: "Extra Pepperoni",
						quantity: 0,
						price: 3,
					},
					{
						_id: shortid.generate(),
						name: "Extra Bacon",
						quantity: 0,
						price: 3,
					},
					{
						_id: shortid.generate(),
						name: "Extra Prawns",
						quantity: 0,
						price: 3,
					},
					{
						_id: shortid.generate(),
						name: "Extra Seafood Mix",
						quantity: 0,
						price: 3,
					},
				],
			},
		];

		await this.saveRestaurant({
			process: (r) => {
				r.menus.push(menu);
				r.option_sets.push(option_sets[0]);
				r.option_sets.push(option_sets[1]);
        if (this.injected.store.isNewMenuSchema) {
          return {
            update: {
              menus: [menu],
              option_sets: option_sets,
            },
          };
        }
				return {
					update: {
						$set: { menus: r.menus, option_sets: r.option_sets },
					},
				};
			},
			successMsg: "Menu template created",
			before: () => this.setState({ loading: true }),
			onSuccess: () => this.setState({ loading: false}),
			onFail: () => this.setState({ loading: false }),
			onError: () => this.setState({ loading: false }),
      isMenuImport: true
		});
	};


    render() {
        const { store } = this.injected;
        const { activeMobileMenu, activeMobileModal, setActiveMobileModal, setActiveMobileMenu } = store;
        const { restaurant } = store
		const r = this.injected.store.restaurant!;
		const { menus, option_sets, dish_tags } = r;
        const { initChargebeeSession } = store.billing
        const { loading, expandedMenus, activeTab, filterText, sortDirection } = this.state;
        const toolbarSortableCount =
            activeTab === "menu"
                ? (store.isNewMenuSchema ? r.menus_v2?.length ?? 0 : menus?.length ?? 0)
                : activeTab === "optionSets"
                ? store.isNewMenuSchema
                ? r.option_sets_v2?.length ?? 0
                : option_sets?.length ?? 0
                : 0;

        return (
			<MenuWrapper>
				<div>
					<>
						<div style={{display: 'flex', flexDirection: 'column', gap: 24}}>
							<SettingsHeader
								style={{ width: 'calc(100% + 4rem)', marginLeft: '-2rem', marginTop: '-2rem'}}>
								<SettingsHeaderTextContainer>
									<SettingsHeaderTextWrapper>
										<SettingsHeaderTextTitle>Menus</SettingsHeaderTextTitle>
										{activeMobileMenu.referrer.length > 0 &&
										<SettingsHeaderTextBreadcrumbs style={{flexDirection: 'row', justifyContent: 'start', gap: 4}}>
											{activeMobileMenu.referrer
											.map((r, index) => <span
												key={index}
												style={{cursor: 'pointer'}}
													onClick={() => store.setActiveMobileMenu(
														store.activeMobileMenu.referrer.pop()!,
														Array.from(new Set(store.activeMobileMenu.referrer))
													)}>
												{r.replace(/-/g, ' ')} {index !== (activeMobileMenu.referrer.length - 1) ? '/': ''}
											</span>)} / {activeMobileMenu.name.replace(/-/g, ' ')}
										</SettingsHeaderTextBreadcrumbs> }
									</SettingsHeaderTextWrapper>
								</SettingsHeaderTextContainer>
							</SettingsHeader>
							<MainContainer
								className={`${(store.organisation && store.organisation.dashboard) || ''} menus-v2`}
								style={{
									display: 'flex',
									flexDirection: 'column',
									gap: 16,
									width: '100%',
									margin: '0 auto',
									paddingLeft: 0
								}}>
								{(activeMobileMenu.name == '' ||
								activeMobileMenu.name == 'menus' ||
								!activeMobileMenu.referrer.includes('menus')) && <>
									<div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
										<div style={{ flex: 1, minWidth: 0 }}>
											<MenuListToolbar
												tabs={[
													{ name: "Menu", value: "menu" },
													{ name: "Option Sets", value: "optionSets" },
													{ name: "Item Tags", value: "itemTags" },
												]}
												activeTab={activeTab}
												onTabChange={(value) =>
													this.setState({ activeTab: value, filterText: "", sortDirection: null })
												}
												filterText={filterText}
												onFilterTextChange={(value) => this.setState({ filterText: value })}
												filterPlaceholder={getMenuListFilterPlaceholder(activeTab)}
												sortDirection={sortDirection}
												onSortDirectionChange={(direction) => this.setState({ sortDirection: direction })}
												showFilter={activeTab === "menu" || activeTab === "optionSets"}
												showSort={activeTab === "menu" || activeTab === "optionSets"}
												sortableItemCount={toolbarSortableCount}
											/>
										</div>
										<ButtonV2
											style={{ padding: '6px 8px', flex: 0, marginTop: 0 }}
											variant='default'
											onClick={() => setActiveMobileModal('desktop-more-actions')}
										><IconMoreOptions /></ButtonV2>
									</div>
									<>
									{activeTab === 'menu' && (
										<RestaurantMenuListV2
											filterText={filterText}
											sortDirection={sortDirection}
										/>
									)}
									{activeTab === 'optionSets' && (
										<RestaurantOptionSetListV2
											filterText={filterText}
											sortDirection={sortDirection}
											onSortDirectionChange={(direction) =>
												this.setState({ sortDirection: direction })
											}
										/>
									)}
									{activeTab === 'itemTags' && (
										<RestaurantDishTagsV2 />
									)}
									</>

								</>}

								{activeMobileMenu.name == 'templates' &&

								<MenuCard
									className='desktop-only'
									style={{padding: 24, gap: 16, borderRadius: 0}}>
									<p>Pick from one of the ready made templates to help you get started building your menu.</p>
									<p>Choosing a template below will create a new menu, it will not overwrite any of your existing menus or items.</p>

									<SettingsActionButtonContainer>
										<SettingsActionButtonWrapper>
											<button
												type="button"
												className='btn-cancel'
												onClick={ () => store.setActiveMobileMenu(
													store.activeMobileMenu.referrer.pop()!,
													Array.from(new Set(store.activeMobileMenu.referrer))
												)}>
												Cancel
											</button>
											<button onClick={this.createPizzaMenu} style={{minWidth: 191}}>
												{loading && <RotateLoader size={2} />}
												{!loading && "Create Pizza Menu"}
											</button>
										</SettingsActionButtonWrapper>
									</SettingsActionButtonContainer>
								</MenuCard>}

								{activeMobileMenu.name == 'upload-services' &&

								<MenuCard
									className='desktop-only'
									style={{padding: 24, gap: 16, borderRadius: 0}}>
										<p>Need a hand uploading your menu? Simply complete the upload request form linked below.</p>
										<p>We will process your request within 48-72 hours, notify you upon completion. Charges apply.</p>

									<SettingsActionButtonContainer>
										<SettingsActionButtonWrapper>
											<button
												type="button"
												className='btn-cancel'
												onClick={ () =>
													window.open(`https://airtable.com/shrTnLexLfBva8wJO?prefill_Restaurant+ID=${restaurant!._id}&prefill_Restaurant+Subdomain=${restaurant!.subdomain}`, '_blank')
												}
												style={{flex: '0 0 auto'}}>
												Go to Upload Form
											</button>
											<button
												onClick={() => initChargebeeSession(restaurant!._id)}
												style={{minWidth: 282}}>
												Update Payment Methods & Subscription
											</button>
										</SettingsActionButtonWrapper>
									</SettingsActionButtonContainer>
								</MenuCard>}
								{(activeMobileMenu.name == 'create-menu' || activeMobileMenu.name == 'edit-menu'
								|| activeMobileMenu.name == 'create-category' || activeMobileMenu.name == 'edit-category'
								|| activeMobileMenu.name == 'create-item' || activeMobileMenu.name == 'edit-item') &&

								<MenuCard
									style={{gap: 16, borderRadius: 0, marginBottom: '100px', width: '100%'}}>
									<RestaurantMenuListV2 loadMenusOnMount={false} />
								</MenuCard>}

								{(activeMobileMenu.name == 'create-option-set' || activeMobileMenu.name == 'edit-option-set') &&
								<MenuCard
									style={{gap: 16, borderRadius: 0}}>
									<RestaurantOptionSetListV2
										filterText={filterText}
										sortDirection={sortDirection}
										onSortDirectionChange={(direction) =>
											this.setState({ sortDirection: direction })
										}
									/>

								</MenuCard>}

								{(activeMobileMenu.name == 'create-dish-tag' || activeMobileMenu.name == 'edit-dish-tag') &&
									<RestaurantDishTagsV2 />
								}
							</MainContainer>
						</div>
						{activeMobileModal == 'menus' && <MobileModal>
							<MobileModalContent style={{
								height: '100%',
								borderRadius: 'unset',
								justifyContent: 'start'
							}}>
								<MobileModalHeader style={{alignItems: 'center'}}>
									More Actions
									<span onClick={() => {
									setActiveMobileModal('')
									}}>
										<IconClose />
									</span>
								</MobileModalHeader>
								<MobileModalBody>
									<SettingsActionButtonWrapper variant='default' position='relative' noborder nopadding>
										<button
											onClick={() => {
												setActiveMobileModal('menus-templates')
											}}>
											Templates
										</button>
									</SettingsActionButtonWrapper>
									<SettingsActionButtonWrapper variant='default'  position='relative' noborder nopadding>
										<button
											onClick={() => {
												setActiveMobileModal('menus-upload-service')
											}}>
											Upload Service
										</button>
									</SettingsActionButtonWrapper>
									<SettingsActionButtonWrapper variant='default'  position='relative' noborder nopadding>
										<button
											onClick={() =>
												window.open(
													'https://support.cloudwaitress.com/getting-started/setup-your-menus',
													'_blank')}>
											Help
										</button>
									</SettingsActionButtonWrapper>
								</MobileModalBody>
								<MobileModalFooter>
									<SettingsActionButtonWrapper style={{right: 0}}>
										<button
											onClick={() => {
												setActiveMobileModal('')
											}}>
											Cancel
										</button>
									</SettingsActionButtonWrapper>
								</MobileModalFooter>
							</MobileModalContent>
						</MobileModal>
						}

						<MenuMoreAction
							show={activeMobileModal === 'desktop-more-actions'}
							title={store.restaurant?.name ?? ''	}
							onHide={() => setActiveMobileModal('')}
							onSave={() => setActiveMobileModal('')}
						/>

						{(activeMobileModal == 'menus-templates' ||
						activeMobileMenu.name == 'templates') && <MobileModal className='menus-v2'>
							<MobileModalContent style={{
								height: '100%',
								borderRadius: 'unset',
								justifyContent: 'start',
							}}>
								<MobileModalHeader style={{
									alignItems: 'center',
								}}>
									Menu Template
									<span onClick={() => {
										if(activeMobileMenu && activeMobileMenu.name) {
											store.setActiveMobileMenu(
											store.activeMobileMenu.referrer.pop()!,
											Array.from(new Set(store.activeMobileMenu.referrer))
										)
									} else setActiveMobileModal('menus')
									}}>
										<IconClose />
									</span>
								</MobileModalHeader>
								<MobileModalBody>
									<p>Pick from one of the ready made templates to help you get started building your menu.</p>
									<p>Choosing a template below will create a new menu, it will not overwrite any of your existing menus or items.</p>

								</MobileModalBody>
								<MobileModalFooter>
									<SettingsActionButtonWrapper style={{right: 0}}>
									<button
										className='btn-cancel'
											onClick={() => {
												if(activeMobileMenu && activeMobileMenu.name) {
													store.setActiveMobileMenu(
														store.activeMobileMenu.referrer.pop()!,
														Array.from(new Set(store.activeMobileMenu.referrer))
													)
												} else setActiveMobileModal('menus')
											}}>
											Cancel
										</button>
									<button
											onClick={this.createPizzaMenu}>
											{loading && <RotateLoader size={2} />}
											{!loading && "Create Pizza Menu"}
										</button>

									</SettingsActionButtonWrapper>
								</MobileModalFooter>
							</MobileModalContent>
						</MobileModal>}

						{(activeMobileModal == 'menus-upload-services' ||
						activeMobileMenu.name == 'upload-services') && <MobileModal className='menus-v2'>
							<MobileModalContent style={{
								height: '100%',
								borderRadius: 'unset',
								justifyContent: 'start',
							}}>
								<MobileModalHeader style={{
									alignItems: 'center',
								}}>
									Menu Upload Service
									<span onClick={() => {
										if(activeMobileMenu && activeMobileMenu.name) {
											store.setActiveMobileMenu(
											store.activeMobileMenu.referrer.pop()!,
											Array.from(new Set(store.activeMobileMenu.referrer))
										)
									} else setActiveMobileModal('menus')
									}}>
										<IconClose />
									</span>
								</MobileModalHeader>
								<MobileModalBody>
									<p>Need a hand uploading your menu? Simply complete the upload request form linked below.</p>
									<p className="lhp big">We will process your request within 48-72 hours, notify you upon completion. Charges apply.</p>
									<SettingsActionButtonWrapper variant='default'  position='relative' noborder nopadding>
										<button
											onClick={() => initChargebeeSession(restaurant!._id)}
											>
										Update Payment Methods & Subscription
										</button>
									</SettingsActionButtonWrapper>
									<SettingsActionButtonWrapper variant='default' position='relative' noborder nopadding>
										<button
											onClick={ () =>
												window.open(`https://airtable.com/shrTnLexLfBva8wJO?prefill_Restaurant+ID=${restaurant!._id}&prefill_Restaurant+Subdomain=${restaurant!.subdomain}`, '_blank')
											}>
										Go to Upload Form
										</button>
									</SettingsActionButtonWrapper>
								</MobileModalBody>
								<MobileModalFooter>
									<SettingsActionButtonWrapper style={{right: 0}}>
									<button

											onClick={() => {
												if(activeMobileMenu && activeMobileMenu.name) {
													store.setActiveMobileMenu(
														store.activeMobileMenu.referrer.pop()!,
														Array.from(new Set(store.activeMobileMenu.referrer))
													)
												} else setActiveMobileModal('menus')
											}}>
											Cancel
										</button>

									</SettingsActionButtonWrapper>
								</MobileModalFooter>
							</MobileModalContent>
						</MobileModal>}

						{activeMobileModal === 'desktop-csv-import' && (
							<CSVImport
								autoOpen
								hideTrigger
								onClose={() => setActiveMobileModal('')}
							/>
						)}
						{activeMobileModal === 'desktop-csv-export' && (
							<CSVExport
								autoExport
								hideTrigger
								onComplete={() => setActiveMobileModal('')}
							/>
						)}
						{activeMobileModal === 'desktop-version-history' && (
							<MenuVersionHistory
								autoOpen
								hideTrigger
								onClose={() => setActiveMobileModal('')}
							/>
						)}

						{(activeMobileModal === 'menus-import-menu' ||
						activeMobileMenu.name == 'import-menu') && <MobileModal className='menus-v2'>
							<MobileModalContent style={{
								height: '100%',
								borderRadius: 'unset',
								justifyContent: 'start',
							}}>
								<MobileModalHeader style={{
									alignItems: 'center',
								}}>
									Import Menu
								</MobileModalHeader>
								<MobileModalBody>
									<CSVImport
										autoOpen
										hideTrigger
										onClose={() => {
											setActiveMobileModal('')
											if (activeMobileMenu.name == 'import-menu') {
												setActiveMobileMenu(store.activeMobileMenu.referrer.pop()!, Array.from(new Set(store.activeMobileMenu.referrer)))
											}
										}}
									/>
								</MobileModalBody>
							</MobileModalContent>
						</MobileModal> }
					</>
				</div>
				{/* <div className='mobile-view'>
				<MobileMenus />
				</div> */}
			</MenuWrapper>
        )
    }
}

